import React from "react";

import { Button, IButtonProps } from "@/components/Button";
import { Icon } from "@/components/Icon";

interface ICloseButtonProps extends IButtonProps {}

export const CloseButton: React.FunctionComponent<ICloseButtonProps> = ({
  onClick,
  testName,
  size = "lg",
  ...buttonProps
}) => (
  <Button variant="clean" onClick={onClick} testName="close" {...buttonProps}>
    <Icon icon="close" size={size} color="grey2" />
  </Button>
);
